import React, { useState } from "react";
import useSWR from "swr";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { api, fmtINR } from "@/lib/api";
import { Skeleton, Pill } from "@/components/Atoms";

const fetcher = (u) => api.get(u).then((r) => r.data);

export default function MgmtCustomers() {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const { data } = useSWR(`/customers?q=${encodeURIComponent(q)}&page=${page}&page_size=25`, fetcher);

  return (
    <div className="space-y-5">
      <div>
        <div className="rc-title-1">Customer Master</div>
        <div className="rc-callout">All customers across all projects.</div>
      </div>

      <div className="rc-card rc-card-padded">
        <div className="relative">
          <Search className="absolute top-1/2 -translate-y-1/2 left-4 text-[var(--rc-grey-icon)] pointer-events-none" size={18}/>
          <input value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="Search by name, email or mobile" className="rc-input" style={{ paddingLeft: 48 }} data-testid="mgmt-search"/>
        </div>
      </div>

      {!data && <Skeleton h={300}/>}

      <div className="rc-card overflow-x-auto" style={{ padding: 0 }}>
        <table className="w-full text-left" style={{ minWidth: 880 }}>
          <thead><tr className="rc-caption uppercase">
            <th className="py-3 px-5 whitespace-nowrap">Customer</th><th className="py-3 px-5 whitespace-nowrap">Flat</th><th className="py-3 px-5 whitespace-nowrap">Project</th>
            <th className="py-3 px-5 whitespace-nowrap">Mobile</th><th className="py-3 px-5 text-right whitespace-nowrap">Outstanding</th><th className="py-3 px-5 whitespace-nowrap">Open</th>
          </tr></thead>
          <tbody>
            {data?.items.map(c => (
              <tr key={c.customer_id} className="border-t border-[var(--rc-line)]">
                <td className="py-3 px-5"><Link to={`/crm/customers/${c.customer_id}`} className="rc-headline hover:underline">{c.customer_name}</Link><div className="rc-caption truncate max-w-[220px]">{c.email}</div></td>
                <td className="py-3 px-5 whitespace-nowrap">{c.flat_info?.flat?.flat_number || "—"}</td>
                <td className="py-3 px-5 whitespace-nowrap">{c.flat_info?.project?.project_name || "—"}</td>
                <td className="py-3 px-5 rc-tabular whitespace-nowrap">{c.primary_phone}</td>
                <td className="py-3 px-5 text-right rc-tabular whitespace-nowrap" style={{ color: c.outstanding > 0 ? "var(--rc-orange)" : "var(--rc-success)" }}>{fmtINR(c.outstanding)}</td>
                <td className="py-3 px-5 whitespace-nowrap">{c.open_tickets > 0 ? <Pill tone="blue">{c.open_tickets}</Pill> : <Pill tone="grey">0</Pill>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!data?.items.length && <div className="rc-footnote py-10 text-center">No customers found.</div>}
      </div>

      {data && data.total > 25 && (
        <div className="flex items-center justify-between">
          <button disabled={page === 1} onClick={() => setPage(p => p - 1)} className="rc-btn rc-btn-sm rc-btn-secondary">Prev</button>
          <div className="rc-footnote">Page {page} of {Math.ceil(data.total / 25)} — {data.total} customers</div>
          <button disabled={page * 25 >= data.total} onClick={() => setPage(p => p + 1)} className="rc-btn rc-btn-sm rc-btn-secondary">Next</button>
        </div>
      )}
    </div>
  );
}
